export const URL_TOP10_DASHBOARD =
 "/Cxp/WebService/CxpWebService.asmx/buscarTop10Dashboard";
export const URL_TARJETAS_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarTarjetasDashboard";   
 export const URL_GRAFICOS_FACTURAS_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarFacturasGraficoDashboard"
 export const URL_GRAFICOS_NOTAS_CREDITO_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarNotasCreditoGraficoDashboard"
 export const URL_GRAFICOS_NOTAS_DEBITO_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarNotasDebitoGraficoDashboard"
 export const URL_GRAFICOS_ORDENES_COMPRA_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarOrdenesCompraGraficoDashboard"
 export const URL_GRAFICOS_PAGOS_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarPagosGraficoDashboard"
 export const URL_GRAFICOS_ANTICIPOS_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarAnticiposGraficoDashboard"
 export const URL_GRAFICOS_TASAS_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/CxpTasasGrafico"
 export const URL_GRAFICOS_ORDENES_COMPRA_TRANSITO_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarOrdenesCompraTransito"
 export const URL_GRAFICOS_ORDENES_COMPRA_LIQUIDACION_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarOrdenesCompraLiquidacion"
 export const URL_GRAFICOS_ORDENES_COMPRA_EN_ALMACEN_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarOrdenesCompraEnAlmacen"
 export const URL_GRID_SUPLIDORES_DASHBOARD = 
 "/Cxp/WebService/CxpWebService.asmx/buscarSuplidoresGrid"
 export const URL_SUPLIDRES_AUTOCOMPLETE_GRID = 
 "/Cxp/WebService/CxpWebService.asmx/BuscarListadoSuplidores"
export const URL_EXPORTAR_SUPLIDORES_GRID = 
    "/Cxp/WebService/CxpWebService.asmx/ExportarGridSuplidoresDashboard";